import React, { useState, useEffect } from 'react';
import { FaPhoneAlt, FaTruck, FaCheckCircle, FaStar, FaWhatsapp } from 'react-icons/fa';
import { MdPlayArrow } from 'react-icons/md';
import { motion, AnimatePresence } from 'framer-motion';

const FarmsPage = () => {
    const [activeTab, setActiveTab] = useState('gallery');
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        // Set loaded state after a short delay to trigger animations
        setTimeout(() => setIsLoaded(true), 300);
    }, []);

  // Replace with your actual content
const ramVideos = [
    { 
        id: 1, 
        url: 'https://res.cloudinary.com/dgqu4ohbw/video/upload/v1742038958/jcb1yaauknugsszxbnxv.mp4', 
        thumbnail: 'https://res.cloudinary.com/dgqu4ohbw/image/upload/v1742038952/kort2k7m5ihffckgqhly.jpg' 
    },
    { 
        id: 2, 
        url: 'https://res.cloudinary.com/dgqu4ohbw/video/upload/v1742038975/dz4upverfydi6izwxw0l.mp4', // Replace with actual URL
        thumbnail: 'https://res.cloudinary.com/dgqu4ohbw/image/upload/v1742038952/kort2k7m5ihffckgqhly.jpg' // Replace with actual thumbnail
    },
    { 
        id: 3, 
        url: 'https://res.cloudinary.com/dgqu4ohbw/video/upload/v1742038973/uwkuy1bd3ixzlsn466ix.mp4', // Replace with actual URL
        thumbnail: 'https://res.cloudinary.com/dgqu4ohbw/image/upload/v1742038952/kort2k7m5ihffckgqhly.jpg' // Replace with actual thumbnail
    },
];
    const ramImages = [
        { id: 1, url: 'https://res.cloudinary.com/dgqu4ohbw/image/upload/v1742038952/kort2k7m5ihffckgqhly.jpg', title: 'Premium Ram 1' },
        { id: 6, url: 'https://res.cloudinary.com/dgqu4ohbw/image/upload/v1742038951/hwuwtp5jdv0ovi5rs8i7.jpg', title: 'Premium Ram 6' },
       
        { id: 2, url: 'https://res.cloudinary.com/dgqu4ohbw/image/upload/v1742038952/kort2k7m5ihffckgqhly.jpg', title: 'Premium Ram 2' },
        { id: 3, url: 'https://res.cloudinary.com/dgqu4ohbw/image/upload/v1742038952/kort2k7m5ihffckgqhly.jpg', title: 'Premium Ram 3' },
        { id: 4,  url: 'https://res.cloudinary.com/dgqu4ohbw/image/upload/v1742038952/kort2k7m5ihffckgqhly.jpg', title: 'Premium Ram 4' },
        { id: 5,  url: 'https://res.cloudinary.com/dgqu4ohbw/image/upload/v1742038952/kort2k7m5ihffckgqhly.jpg', title: 'Premium Ram 5' },
    ];

    const testimonials = [
        {
            id: 1,
            name: 'John D.',
            location: 'Lagos',
            text: 'The quality of rams from The Grill Shack Farm is unmatched. Excellent service and delivery!',
            rating: 5
        },
        {
            id: 2,
            name: 'Sarah M.',
            location: 'Lagos',
            text: 'I\'ve been buying rams from them for 3 years. Always healthy and well-bred animals.',
            rating: 5
        },
        {
            id: 3,
            name: 'Ahmed K.',
            location: 'Lagos Mainland',
            text: 'Fast delivery and the rams were exactly as described. Will order again!',
            rating: 4
        },
    ];

    // Animation variants
    const fadeIn = {
        hidden: { opacity: 0, y: 20 },
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: {
                delay: i * 0.1,
                duration: 0.5,
                ease: "easeOut"
            }
        })
    };

    const staggerContainer = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1
            }
        }
    };

    const imageHover = {
        rest: { scale: 1, transition: { duration: 0.3, ease: "easeInOut" } },
        hover: { scale: 1.05, transition: { duration: 0.3, ease: "easeInOut" } }
    };

    return (
        <div className="bg-black text-white min-h-screen overflow-hidden">
            {/* Hero Section */}
{/* Hero Section */}
<motion.div
    className="relative"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 1 }}
>
    <div className="w-full h-96 md:h-screen bg-gradient-to-r from-black to-transparent relative overflow-hidden">
        <motion.div
            className="absolute inset-0 bg-cover bg-center opacity-40"
            style={{ backgroundImage: "url('YOUR_FARM_HERO_IMAGE')" }}
            animate={{
                scale: [1, 1.05, 1],
            }}
            transition={{
                duration: 20,
                repeat: Infinity,
                repeatType: "reverse"
            }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black to-transparent" />
        <div className="container mx-auto px-4 h-full flex flex-col justify-center items-center relative z-10">
            <motion.div
                className="flex flex-col md:flex-row items-center justify-center w-full"
                initial={{ opacity: 0, y: -50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, delay: 0.3 }}
            >
                <div className="md:w-1/2 text-center md:text-right md:pr-8">
                    <h1 className="text-4xl md:text-6xl font-bold mb-4">
                        <span className="text-red-600">THE GRILL SHACK</span> <br />
                        <motion.span
                            className="text-yellow-500"
                            animate={{
                                textShadow: ["0px 0px 0px rgba(234, 179, 8, 0)", "0px 0px 10px rgba(234, 179, 8, 0.5)", "0px 0px 0px rgba(234, 179, 8, 0)"]
                            }}
                            transition={{ duration: 3, repeat: Infinity }}
                        >FARM</motion.span>
                    </h1>
                </div>
                <div className="md:w-1/2 flex justify-center md:justify-start mt-6 md:mt-0">
                    <motion.div
                        className="w-64 md:w-80 lg:w-96 rounded-lg overflow-hidden shadow-2xl"
                        whileHover={{ scale: 1.05 }}
                        transition={{ duration: 0.3 }}
                    >
                        <img
                            src="https://res.cloudinary.com/dgqu4ohbw/image/upload/v1742042883/poster_gvwkqd.jpg"
                            alt="The Grill Shack Poster"
                            className="w-full h-auto"
                        />
                    </motion.div>
                </div>
            </motion.div>
            <motion.p
                className="text-xl md:text-2xl max-w-xl mb-8 text-center mt-8"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.7, delay: 0.6 }}
            >
                Premium quality rams for all your needs - delivered across mainland and the island
            </motion.p>
            <motion.div
                className="flex flex-col sm:flex-row gap-4 mt-4 mb-16"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, delay: 0.9 }}
            >
            
<motion.a
    href="https://wa.me/2347040606437?text=Hello%20I%20would%20like%20to%20place%20an%20order"
    target="_blank" 
    rel="noopener noreferrer"
    className="bg-red-600 text-white px-6 py-3 rounded-md text-lg font-bold hover:bg-red-700 transition-colors flex items-center justify-center"
    whileHover={{ scale: 1.05 }}
    whileTap={{ scale: 0.95 }}
>
    <FaPhoneAlt className="mr-2" /> Contact Us
</motion.a>
<motion.a
    href="#gallery"
    onClick={(e) => {
        e.preventDefault();
        setActiveTab('gallery'); // This sets the active tab to gallery
        document.getElementById('gallery').scrollIntoView({ behavior: 'smooth' });
    }}
    className="border-2 border-white text-white px-6 py-3 rounded-md text-lg font-bold hover:bg-white hover:text-black transition-colors flex items-center justify-center"
    whileHover={{ scale: 1.05 }}
    whileTap={{ scale: 0.95 }}
>
    View Our Rams
</motion.a>
            </motion.div>
        </div>
    </div>
</motion.div>
            {/* Features Section */}
            <div className="bg-black py-16">
                <div className="container mx-auto px-4">
                    <motion.div
                        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8"
                        variants={staggerContainer}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.3 }}
                    >
                        {[
                            {
                                icon: <FaCheckCircle />,
                                title: "Premium Quality",
                                text: "We sell only the finest quality rams, carefully selected and bred to perfection."
                            },
                            {
                                icon: <FaTruck />,
                                title: "Nationwide Delivery",
                                text: "We deliver to all locations across mainland and the island. No distance is too far."
                            },
                            {
                                icon: <FaStar />,
                                title: "Custom Orders",
                                text: "We slaughter rams to your specific needs and preferences."
                            },
                            {
                                icon: <FaCheckCircle />,
                                title: "Health Guaranteed",
                                text: "All our rams are healthy, well-fed, and maintained in excellent condition."
                            }
                        ].map((feature, i) => (
                            <motion.div
                                key={i}
                                className="bg-gray-900 p-6 rounded-lg text-center"
                                variants={fadeIn}
                                custom={i}
                                whileHover={{
                                    y: -10,
                                    boxShadow: "0 10px 20px rgba(220, 38, 38, 0.2)"
                                }}
                                transition={{ duration: 0.3 }}
                            >
                                <motion.div
                                    className="text-red-600 text-4xl mb-4 inline-block"
                                    animate={{
                                        rotateY: [0, 360]
                                    }}
                                    transition={{
                                        duration: 3,
                                        delay: i * 0.5,
                                        repeat: Infinity,
                                        repeatDelay: 5
                                    }}
                                >
                                    {feature.icon}
                                </motion.div>
                                <h3 className="text-xl font-bold mb-2">{feature.title}</h3>
                                <p className="text-gray-300">{feature.text}</p>
                            </motion.div>
                        ))}
                    </motion.div>
                </div>
            </div>

            {/* Content Tabs */}
            <div id="gallery" className="py-16 bg-gray-900">
                <div className="container mx-auto px-4">
                    <motion.div
                        className="text-center mb-12"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.7 }}
                    >
                        <h2 className="text-3xl md:text-4xl font-bold mb-4">Our Premium Rams</h2>
                        <p className="text-xl text-gray-300 max-w-2xl mx-auto">
                            Browse our selection of high-quality rams available for purchase or custom slaughter
                        </p>
                    </motion.div>

                    <motion.div
                        className="flex justify-center mb-8"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.7, delay: 0.2 }}
                    >
                        <div className="inline-flex bg-black rounded-lg p-1">
                            {['gallery', 'videos', 'testimonials'].map((tab, index) => (
                                <motion.button
                                    key={tab}
                                    onClick={() => setActiveTab(tab)}
                                    className={`px-4 py-2 rounded-md ${activeTab === tab ? 'bg-red-600 text-white' : 'text-gray-300'}`}
                                    whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                >
                                    {tab === 'gallery' ? 'Photo Gallery' :
                                        tab === 'videos' ? 'Videos' : 'Testimonials'}
                                </motion.button>
                            ))}
                        </div>
                    </motion.div>

                    <AnimatePresence mode="wait">
                        {activeTab === 'gallery' && (
                            <motion.div
                                key="gallery"
                                className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                transition={{ duration: 0.5 }}
                                variants={staggerContainer}
                            >
                                {ramImages.map((image, i) => (
                                    <motion.div
                                        key={image.id}
                                        className="bg-gray-800 rounded-lg overflow-hidden"
                                        variants={fadeIn}
                                        custom={i}
                                        whileInView="visible"
                                        viewport={{ once: true }}
                                        initial="hidden"
                                        whileHover="hover"
                                        initial="rest"
                                        variants={imageHover}
                                    >
                                        <div className="aspect-w-16 aspect-h-9 relative">
                                            <div className="w-full h-64 bg-gray-700">
                                            <img 
    src={image.url} 
    alt={image.title}
    className="w-full h-64 object-cover" 
    onError={(e) => {
        e.target.onerror = null;
        e.target.src = "https://placehold.co/600x400?text=Image+Not+Found";
    }}
/>
                                            </div>
                                        </div>
                                        <div className="p-4">
                                            <h3 className="text-xl font-bold">{image.title}</h3>
                                            <div className="flex justify-between items-center mt-4">
                                                <span className="text-yellow-500 font-bold">Premium Quality</span>
                                                <motion.button
                                                    className="bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700 transition-colors"
                                                    whileHover={{ scale: 1.05 }}
                                                    whileTap={{ scale: 0.95 }}
                                                >
                                                    Enquire
                                                </motion.button>
                                            </div>
                                        </div>
                                    </motion.div>
                                ))}
                            </motion.div>
                        )}

{activeTab === 'videos' && (
    <motion.div
        key="videos"
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
        variants={staggerContainer}
    >
        {ramVideos.map((video, i) => (
            <motion.div
                key={video.id}
                className="bg-gray-800 rounded-lg overflow-hidden"
                variants={fadeIn}
                custom={i}
                whileInView="visible"
                viewport={{ once: true }}
                initial="hidden"
                whileHover="hover"
                variants={imageHover}
            >
<div className="aspect-w-16 aspect-h-9 relative">
    <div className="w-full h-48 bg-gray-700 relative">
        {/* Video element with poster (thumbnail) */}
        <video 
            src={video.url}
            className="w-full h-full object-cover"
            poster={video.thumbnail}
            id={`video-${video.id}`}
            preload="none"
            onClick={(e) => {
                // Toggle play/pause when clicking on the video
                if (e.target.paused) {
                    e.target.play();
                } else {
                    e.target.pause();
                }
            }}
        />
        {/* Play button overlay */}
        <div 
            className="absolute inset-0 flex items-center justify-center cursor-pointer"
            id={`play-button-${video.id}`}
            onClick={(e) => {
                const videoElement = document.getElementById(`video-${video.id}`);
                if (videoElement) {
                    videoElement.play();
                    e.currentTarget.style.display = 'none';
                    
                    // Add event listener for when video ends
                    videoElement.addEventListener('ended', () => {
                        document.getElementById(`play-button-${video.id}`).style.display = 'flex';
                    });
                    
                    // Show controls when user hovers over video
                    videoElement.addEventListener('mouseenter', () => {
                        videoElement.controls = true;
                    });
                    
                    // Hide controls when mouse leaves
                    videoElement.addEventListener('mouseleave', () => {
                        videoElement.controls = false;
                    });
                }
            }}
        >
            <motion.div
                className="w-16 h-16 rounded-full bg-red-600 flex items-center justify-center"
                whileHover={{
                    scale: 1.2,
                    boxShadow: "0 0 20px rgba(220, 38, 38, 0.5)"
                }}
                transition={{ type: "spring", stiffness: 400, damping: 10 }}
            >
                <MdPlayArrow size={30} />
            </motion.div>
        </div>
    </div>
</div>
                <div className="p-4">
                    <h3 className="text-lg font-bold">Ram Video {video.id}</h3>
                    <p className="text-gray-400 mt-2">Watch our rams roaming freely in their natural habitat</p>
                </div>
            </motion.div>
        ))}
    </motion.div>
)}

                        {activeTab === 'testimonials' && (
                            <motion.div
                                key="testimonials"
                                className="grid grid-cols-1 md:grid-cols-3 gap-6"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                transition={{ duration: 0.5 }}
                                variants={staggerContainer}
                            >
                                {testimonials.map((testimonial, i) => (
                                    <motion.div
                                        key={testimonial.id}
                                        className="bg-gray-800 p-6 rounded-lg"
                                        variants={fadeIn}
                                        custom={i}
                                        whileInView="visible"
                                        viewport={{ once: true }}
                                        initial="hidden"
                                        whileHover={{
                                            y: -5,
                                            boxShadow: "0 10px 20px rgba(0, 0, 0, 0.2)"
                                        }}
                                    >
                                        <motion.div
                                            className="flex mb-4"
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            transition={{ delay: 0.2 + i * 0.1, duration: 0.5 }}
                                        >
                                            {[...Array(testimonial.rating)].map((_, i) => (
                                                <motion.div
                                                    key={i}
                                                    initial={{ rotate: -30, opacity: 0 }}
                                                    animate={{ rotate: 0, opacity: 1 }}
                                                    transition={{ delay: 0.5 + i * 0.1, duration: 0.3 }}
                                                >
                                                    <FaStar className="text-yellow-500" />
                                                </motion.div>
                                            ))}
                                        </motion.div>
                                        <p className="text-gray-300 mb-4">"{testimonial.text}"</p>
                                        <div className="flex items-center">
                                            <div className="w-10 h-10 rounded-full bg-gray-600 mr-3">
                                                {/* Placeholder for profile image */}
                                            </div>
                                            <div>
                                                <p className="font-bold">{testimonial.name}</p>
                                                <p className="text-gray-400 text-sm">{testimonial.location}</p>
                                            </div>
                                        </div>
                                    </motion.div>
                                ))}
                            </motion.div>
                        )}
                    </AnimatePresence>
                </div>
            </div>

            {/* CTA Section */}
            <motion.div
                className="py-16 bg-gradient-to-r from-red-900 to-black"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7 }}
            >
                <div className="container mx-auto px-4 text-center">
                    <motion.h2
                        className="text-3xl md:text-4xl font-bold mb-4"
                        initial={{ opacity: 0, y: -20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.7 }}
                    >
                        Ready to Order Your Premium Ram?
                    </motion.h2>
                    <motion.p
                        className="text-xl mb-8 max-w-2xl mx-auto"
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.7, delay: 0.2 }}
                    >
                        Contact us today to discuss your requirements and place an order for premium quality rams
                    </motion.p>
                    <motion.div
                        id="contact"
                        className="bg-black bg-opacity-50 p-8 rounded-lg max-w-xl mx-auto"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.7, delay: 0.4 }}
                        whileHover={{
                            boxShadow: "0 10px 30px rgba(220, 38, 38, 0.3)",
                        }}
                    >
                        <div className="text-2xl font-bold mb-6 text-yellow-500">Contact Information</div>
                        <motion.div
                            className="mb-4 flex items-center"
                            whileHover={{ scale: 1.03, x: 5 }}
                            transition={{ type: "spring", stiffness: 400, damping: 10 }}
                        >
                            <FaPhoneAlt className="mr-3 text-red-600" />
                            <a href="tel:07040606968" className="text-xl hover:text-red-600 transition-colors">07040606968</a>
                        </motion.div>
                        <p className="mt-6 text-gray-300">
                            For all enquiries about our rams, pricing, and delivery options, please call us or send a message.
                        </p>
                        <div className="mt-8">
                            <motion.a
                                href="https://wa.me/2347040606968?text=Hello%20I%20would%20like%20to%20place%20an%20order"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-red-600 text-white px-8 py-3 rounded-md text-lg font-bold hover:bg-red-700 transition-colors inline-flex items-center"
                                whileHover={{ scale: 1.05, backgroundColor: "#b91c1c" }}
                                whileTap={{ scale: 0.95 }}
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ delay: 0.8 }}
                            >
                                <FaWhatsapp className="mr-2" /> Place Your Order
                            </motion.a>
                        </div>
                    </motion.div>
                </div>
            </motion.div>

            {/* FAQ Section */}
            <div className="py-16 bg-black">
                <div className="container mx-auto px-4">
                    <motion.h2
                        className="text-3xl font-bold mb-12 text-center"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.7 }}
                    >
                        Frequently Asked Questions
                    </motion.h2>
                    <motion.div
                        className="max-w-3xl mx-auto space-y-6"
                        variants={staggerContainer}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.3 }}
                    >
                        {[
                            {
                                question: "Do you deliver to all locations?",
                                answer: "Yes, we deliver all over mainland and the island. We ensure your rams are delivered safely and in excellent condition."
                            },
                            {
                                question: "Can I select a specific ram?",
                                answer: "Absolutely! You can visit our farm or choose from our gallery. We can also send you additional photos and videos of available rams."
                            },
                            {
                                question: "Do you offer slaughtering services?",
                                answer: "Yes, we slaughter rams to your specific needs. Our experienced team ensures the process is done properly according to standards."
                            },
                            {
                                question: "How do I place an order?",
                                answer: "Simply call our contact number to discuss your requirements. We'll guide you through the selection, payment, and delivery process."
                            }
                        ].map((faq, i) => (
                            <motion.div
                                key={i}
                                className="bg-gray-900 rounded-lg p-6"
                                variants={fadeIn}
                                custom={i}
                                whileHover={{
                                    x: 5,
                                    boxShadow: "0 5px 15px rgba(220, 38, 38, 0.2)"
                                }}
                            >
                                <h3 className="text-xl font-bold mb-2">{faq.question}</h3>
                                <p className="text-gray-300">{faq.answer}</p>
                            </motion.div>
                        ))}
                    </motion.div>
                </div>
            </div>

            {/* Floating WhatsApp Button */}
            <motion.div
                className="fixed bottom-6 right-6 z-50"
                initial={{ opacity: 0, scale: 0 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{
                    type: "spring",
                    stiffness: 260,
                    damping: 20,
                    delay: 1.5
                }}
            >
                <motion.a
                    href="https://wa.me/2347040606968?text=Hello%20I%20would%20like%20to%20place%20an%20order"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center w-16 h-16 bg-green-500 rounded-full shadow-lg"
                    whileHover={{
                        scale: 1.1,
                        boxShadow: "0 0 25px rgba(34, 197, 94, 0.5)"
                    }}
                    whileTap={{ scale: 0.9 }}
                    animate={{
                        y: [0, -10, 0],
                    }}
                    transition={{
                        y: {
                            duration: 2,
                            repeat: Infinity,
                            repeatType: "reverse"
                        }
                    }}
                >
                    <FaWhatsapp size={32} color="white" />
                </motion.a>
            </motion.div>

            {/* Scroll to Top Button */}
            <motion.button
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className="fixed bottom-6 left-6 z-50 w-12 h-12 bg-red-600 rounded-full flex items-center justify-center shadow-lg"
                initial={{ opacity: 0 }}
                animate={{
                    opacity: 1,
                    rotate: [0, 0, 180, 180, 0],
                }}
                transition={{
                    opacity: { delay: 2 },
                    rotate: { delay: 2.5, duration: 1.5 }
                }}
                whileHover={{
                    scale: 1.1,
                    boxShadow: "0 0 15px rgba(220, 38, 38, 0.5)"
                }}
                whileTap={{ scale: 0.9 }}
            >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
                </svg>
            </motion.button>
        </div>
    );
};

export default FarmsPage;